import {useEffect, useState} from 'react';
import axios from 'axios';
import {Product} from "../pages/RecommendationsPage/RecommendationsPage";
import {fetchRecommendationsAPI} from "../api/axiosRequests";

export function useRecommendations(shop: string | null, showToast: (msg: string) => void, billingActive: boolean) {
    const [recommendations, setRecommendations] = useState([]);
    const [productMap, setProductMap] = useState({});
    const [searchValue, setSearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    // debounce search
    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedSearch(searchValue);
            setPage(1);
        }, 300);
        return () => clearTimeout(timeout);
    }, [searchValue]);

    // fetch data
    useEffect(() => {
        (async () => await fetchRecs())();
        // eslint-disable-next-line
    }, [page, debouncedSearch]);

    const fetchRecs = async () => {
        setLoading(true);
        try {
            const res = await fetchRecommendationsAPI(shop, page, debouncedSearch);
            setRecommendations(res.data.recommendations.data);
            setPage(res.data.recommendations.current_page);
            setTotalPages(res.data.recommendations.last_page);
            const map: Record<number, Product> = {};
            res.data.products.forEach((p: Product) => {
                map[p.shopify_product_id] = p;
            });

            setProductMap(map);
        } catch {
            showToast('Failed to load recommendations');
        } finally {
            setLoading(false);
        }
    };

    return {
        recommendations,
        productMap,
        searchValue,
        setSearchValue,
        page,
        setPage,
        totalPages,
        loading,
        fetchRecs,
    };
}
